import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const fastumTicketTypeSchema = z.object({
  code: z.string().optional(),
  text: z.string(),
});

export const fastumTicketClassSchema = z.object({
  code: z.string().optional(),
  text: z.string(),
});

export const fastumTicketSchema = surrealRecordSchema.extend({
  externalId: z.string(),
  link: z.string().url(),
  status: z.string().optional(),
  type: fastumTicketTypeSchema.optional(),
  title: z.string(),
  class: fastumTicketClassSchema.optional(),
  createdAt: z.coerce.date(),
  actionAt: z.coerce.date().optional(),
  updateAt: z.coerce.date().optional(),
  deletedAtSource: z.boolean().default(false),
});

export const fastumTicketsSchema = z.array(fastumTicketSchema);

export type FastumTicketType = z.infer<typeof fastumTicketTypeSchema>;
export type FastumTicketClass = z.infer<typeof fastumTicketClassSchema>;
export type FastumTicket = z.infer<typeof fastumTicketSchema>;
